import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserStats = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 20C3.0001 18.8809 3.26765 17.7775 3.78089 16.7798C4.29413 15.782 5.03856 14.918 5.95364 14.2579C6.86872 13.5979 7.92862 13.1605 9.04713 12.9813C10.1656 12.8021 11.3112 12.8862 12.3906 13.2267M12.9 19.8954V17.3333M16.95 19.8954V13.7778M21 19.8954V10.2222M14.7 8.44444C14.7 10.899 12.6853 12.8889 10.2 12.8889C7.71472 12.8889 5.7 10.899 5.7 8.44444C5.7 5.98985 7.71472 4 10.2 4C12.6853 4 14.7 5.98985 14.7 8.44444Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgUserStats);
export { ForwardRef as ReactComponent };
